import React from 'react'
import { Link } from 'react-router-dom'
import { useRouteError } from 'react-router-dom';
import { styles } from '../styles/style';
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';
const ErrorPage = () => {

  
    const error = useRouteError();
    console.error(error);


  return (
    <>
    <Navbar/>
      <div className="h-[75vh] m-auto flex flex-col items-center justify-center">
        <h1 className="text-3xl 800px:text-5xl font-bold font-poppins text-blue-900">
          Page Not Found
        </h1>
        <p className="800px:text-[30px] text-[20px]">
          Sorry, we couldn't find the page.
        </p>
        <button className={`${styles.button} !w-fit mt-8`}>
          <Link to="/">Go to Homepage</Link>
        </button>
      </div>
      <Footer />
    </>
  )
}

export default ErrorPage
